/** 天地图WEB服务api二次封装 */
import axios from 'axios'

/**
 * 参数说明
 * @param     {String}      proxy       必传。在线天地图服务地址代理名。需代理地址为：http://api.tianditu.gov.cn
 * @param     {String}      [key]       非必传。天地图开发者秘钥
 */
class TianDi
{
  constructor(opts)
  {
    this.proxy = opts.proxy

    let Ip = window.location.hostname
    let key = null
    if (Ip === 'localhost')
      key = '8de977c887c6cd132862d97d9f8706d5'
    else if (Ip === '127.0.0.1')
      key = '8de977c887c6cd132862d97d9f8706d5'
    else
      key = '02da3c19240aed3f381b808153cdbafc'
    // this.key = opts.key || '8de977c887c6cd132862d97d9f8706d5'
    // this.key = opts.key || '02da3c19240aed3f381b808153cdbafc'
    this.key = opts.key || key
  }

  async get(param, option)
  {
    const options =
    {
      method: 'get',
      url: `/${this.proxy}/${option.funciton}`,
      ...option
    }
    const keyName = options.method === 'get' ? 'params' : 'data'
    options[keyName] = {tk: this.key, ...param}
    const ret = await axios(options)
    return ret.status === 200 ? ret.data : null
  }

  /**
   * 根据地名检索坐标。
   * @method
   * @param     {String}          code   区域名称，如：北京天安门
   * @returns   {Array<Number>}   地名对应的位置坐标
   */
  async getQyCoor(code)
  {
    const ret = await this.get({ds: {keyWord: code}}, {funciton: 'geocoder'})
    if (!ret)
      return []
    return [ret.location.lon, ret.location.lat]
  }
}

export default TianDi



// WEBPACK FOOTER //
// ./src/lib/TianDiApi.js